/* eslint-disable react/no-array-index-key */
interface Props {
  rows?: number
  className?: string
  speed?: number
  randomStart?: boolean
}

export default function LoaderSkeleton({ className, rows = 1, speed, randomStart }: Props): React.ReactElement {
  const backgroundImage = `
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0))
  `

  return Array(rows)
    .fill(null)
    .map((_, i) => {
      const animationDuration = speed ?? 600
      const animationDelay = randomStart && speed ? `-${Math.random() * animationDuration}ms` : undefined

      return (
        <div className={`relative overflow-hidden bg-gray-extra-light ${className}`} key={i}>
          <div
            className="absolute inset-0 transform -translate-x-full"
            style={{
              backgroundImage,
              animation: `shimmer ${animationDuration}ms infinite`,
              ...(animationDelay ? { animationDelay } : {}),
            }}
          />
        </div>
      )
    })
}
